import { useLocalStorageMeta } from '../../../../hooks/useLocalStorageMeta.ts';

export enum EnumContentSize {
  BOXED = 'boxed',
  FULL_WIDTH = 'full-width',
}

/**
 * Hook per la gestione della dimensione della pagina di una tabella,
 * che permette il salvataggio dell'ultima preferenza usata nel local storage
 */
export function useLocalTableContentSize(
  key: string,
  current: EnumContentSize | null | undefined,
  options?: { defaultValue?: EnumContentSize },
): {
  contentSize: EnumContentSize;
} {
  const { value } = useLocalStorageMeta(key, current?.toString());
  const result: EnumContentSize =
    value == EnumContentSize.FULL_WIDTH
      ? EnumContentSize.FULL_WIDTH
      : (options?.defaultValue ?? EnumContentSize.BOXED);

  return { contentSize: result };
}
